import React, { useContext, useRef, useState } from 'react'
import './Othercontains.css'
import milkcan from "../../imgs/tvatap.webp";
import bonus from "../../imgs/bonus.png";
import Box from '../Box/Box';
import Cowleft from "../../imgs/cowleft.gif";
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog/Dialog';
import Globalcontext from '../../Context/Globalcontext';
import Thevvatap from '../Thevvatap/Thevvatap';
import Bonus from '../Bonus/Bonus';

import { useTranslation } from "react-i18next";

const Othercontains = (props) => {
    const [mastermenu, setMastermenu] = useState(true);
    const [showBackImage, setShowBackImage] = useState(false);
    const [transitionEnded, setTransitionEnded] = useState(true);
    const [kopen, setkopen] = useState(0);

    const { submenu, setsubmenu } = useContext(Globalcontext);
    const { setHeadname } = useContext(Globalcontext);

    const [t] = useTranslation();

    const navigate = useNavigate();
    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    const areUSure = () => {
        handleDialog("", false);
    };

    const openkendra = () => {
        setShowBackImage(true);
        setMastermenu(false);
        setTransitionEnded(true);
        setsubmenu("kendra");
        setkopen(1);
    }

    const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({ message, isLoading, nameProduct });
    };

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setsubmenu("");
        setHeadname(t("head.other_voucher"));
    }

    const handleTransitionEnd = () => {
        if (!mastermenu) setShowBackImage(true);
        else setShowBackImage(false);
        setTransitionEnded(true);
    };

    return (
        <>
            <div className='line' />
            <div className="maincon">

                <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>{t("head.other_voucher_plural")}</span>

                <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                    <Box
                        action="thevvatap"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"}
                        head={t("other.boxes.thevvatap")}
                        img={<img src={milkcan} alt="" />}
                    />
                    <Box
                        action="bonus"
                        setsubmenu={setsubmenu}
                        visibility={visibility}
                        background={"linear-gradient(179deg, var(--t3dark), var(--t3dark))"}
                        head={t("other.boxes.bonus")}
                        img={<img src={bonus} alt="" />}
                    />
                </div>

                <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
                    <div className="first"></div>
                    <div className="second">
                        <div className='line' />
                        <span className='firstspan'>{t("other.info.1")}</span>
                        <span className='infospan'>{t("other.info.2")}</span>
                        <span className='infospan'>{t("other.info.3")}</span>
                    </div>
                </div>

                <div className={`cust ${mastermenu ? 'hidden' : ''}`}>
                    {transitionEnded && showBackImage && (
                        submenu === "thevvatap" ? <Thevvatap setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                            submenu === "bonus" ? <Bonus setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} /> :
                                ""
                    )}
                </div>

            </div>

            <div className="secrow">
                <div className="leftsecrow"></div>
                {submenu !== "thevvatap" && submenu !== "bonus" ? (
                    <div className="imgcon">
                        <img className='imgcowtran' src={Cowleft} alt="" />
                    </div>
                ) : ""}
            </div>

            {dialog.isLoading && (
                <Dialog
                    submessage={dialog.nameProduct}
                    onDialog={areUSure}
                    message={dialog.message}
                    functionname={openkendra}
                    button1text={t("dialog.no")}
                    button2text={t("dialog.yes")}
                />
            )}
        </>
    )
}

export default Othercontains
